import React from 'react';
import {
  Row,
  Col,
  Layout,
  Menu,
  Table,
  Descriptions,
  Typography,
  notification,
  Icon,
  Tabs,
  Popconfirm,
  Button,
  Select,
  DatePicker,
} from 'antd';
import CommonTypeProps from '../../../common/CommonTypeProps';
import _, { isArray, size } from 'lodash';
import { LinkO2O } from '../../../common/LinkO2O';
import { UserTokens, TypeUserToken } from './model/usertoken';
import { ColumnProps } from 'antd/lib/table';
import { FormattedDate } from 'react-intl';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getCurrentURL, getPrimaryColor } from '../../../common/helper';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';
import { InfoList, LongTextTd, O2OCustomPaging } from 'o2o_layout';
import { TypeCriteriaSearchUserToken } from './dal/UserTokenDAL';
import styled from 'styled-components';
import { IconLogout } from '@shares/DMPIcon';
import Form, { FormComponentProps } from 'antd/lib/form';
import { O2OFormItem } from '@shares/O2OFormItem';
import moment from 'moment';

interface Props extends CommonTypeProps {
  getUserTokens: any;
  userTokens: UserTokens;
  logoutById: any;
}

const CustomDescriptions = styled(Descriptions)`
  margin-top: 10px;
  margin-bottom: 8px;

  .ant-descriptions-title {
    margin-bottom: 10px;
  }

  .ant-descriptions-item {
    padding-bottom: 5px;
  }
`;

interface IFilterUserTokenProps extends FormComponentProps {
  onSearch: (payload: any) => void;
  loading: boolean;
}

const FilterUserToken = Form.create<IFilterUserTokenProps>()(({ form, onSearch, loading }: IFilterUserTokenProps) => {
  const onSubmit = () => {
    form.validateFields((err, values: any) => {
      if (!err) {
        if (isArray(values.time) && size(values.time) === 2) {
          values['fromIssuedAt'] = moment(values.time[0]).toDate().getTime();
          values['toIssuedAt'] = moment(values.time[1]).toDate().getTime();
        } else {
          values['fromIssuedAt'] = 0;
          values['toIssuedAt'] = 0;
        }
        delete values.time;
        onSearch(values);
      }
    });
  };

  return (
    <Form hideRequiredMark colon={false}>
      <Row gutter={[10, 10]} type='flex'>
        <Col sm={24} lg={8} xl={6} xxl={6}>
          <O2OFormItem label='Types'>
            {form.getFieldDecorator(
              'types',
              {}
            )(<Select maxTagCount={1} maxTagTextLength={6} mode='tags' placeholder='Enter(s)' showArrow allowClear></Select>)}
          </O2OFormItem>
        </Col>
        <Col xs={24} lg={8} xl={6} xxl={6}>
          <O2OFormItem label='Issued Time'>
            {form.getFieldDecorator(
              'time',
              {}
            )(
              <DatePicker.RangePicker
                allowClear
                style={{ width: '100%' }}
                showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }}
              />
            )}
          </O2OFormItem>
        </Col>
        <Col>
          <O2OFormItem label={<></>}>
            <Button loading={loading} onClick={onSubmit} icon='search' type='primary'>
              Search
            </Button>
          </O2OFormItem>
        </Col>
      </Row>
    </Form>
  );
});

export class UserTokenComponentV2 extends React.Component<Props, any> {
  state = {
    criteria: {
      page: 0,
      pageSize: 10,
    } as TypeCriteriaSearchUserToken,
    columns: [
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        ellipsis: false,
        width: 80,
        render: (text: any, record: TypeUserToken, index: number) => {
          return record.type ? <LongTextTd text={record.type} /> : '--/--';
        },
      },
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        ellipsis: true,
        width: 410,
        render: (text: any, record: TypeUserToken, index: number) => {
          return record.id ? <LongTextTd text={record.id} /> : '--/--';
        },
      },
      {
        title: 'Org Id',
        dataIndex: 'orgId',
        key: 'orgId',
        ellipsis: false,
        width: 280,
        render: (text: any, record: TypeUserToken, index: number) => {
          return record.orgId ? <LongTextTd text={record.orgId} /> : '--/--';
        },
      },
      {
        title: 'Issued At',
        dataIndex: 'issuedAt',
        key: 'issuedAt',
        width: 200,
        render: (text: any, record: TypeUserToken, index: number) => {
          return record.issuedAt ? (
            <FormattedDate
              value={new Date(record.issuedAt)}
              year='numeric'
              month='2-digit'
              day='2-digit'
              hour='2-digit'
              minute='2-digit'
              second='2-digit'
            />
          ) : (
            '--/--'
          );
        },
      },
      {
        title: 'Last Accessed',
        dataIndex: 'lastAccessedAt',
        key: 'lastAccessedAt',
        ellipsis: true,
        width: 200,
        render: (text: any, record: TypeUserToken, index: number) => {
          return record.lastAccessedAt ? (
            <FormattedDate
              value={new Date(record.lastAccessedAt)}
              year='numeric'
              month='2-digit'
              day='2-digit'
              hour='2-digit'
              minute='2-digit'
              second='2-digit'
            />
          ) : (
            '--/--'
          );
        },
      },
      {
        title: 'Expired Time',
        dataIndex: 'expiredAt',
        key: 'expiredAt',
        ellipsis: true,
        width: 200,
        render: (text: any, record: TypeUserToken, index: number) => {
          return record.expiredAt ? (
            <FormattedDate
              value={new Date(record.expiredAt)}
              year='numeric'
              month='2-digit'
              day='2-digit'
              hour='2-digit'
              minute='2-digit'
              second='2-digit'
            />
          ) : (
            '--/--'
          );
        },
      },
      {
        title: 'Logout',
        dataIndex: 'lastAccessedAt',
        key: 'lastAccessedAt',
        width: 80,
        fixed: 'right',
        align: 'center',
        render: (text: any, record: TypeUserToken, index: number) => {
          return (
            <Popconfirm
              title='Are you sure logout this session?'
              onConfirm={() => {
                this.logOutId(record);
              }}
            >
              <Button size='small' type='link'>
                <Icon component={IconLogout} />
              </Button>
            </Popconfirm>
          );
        },
      },
    ] as ColumnProps<{}>[],
  };

  logOutId = (record: TypeUserToken) => {
    this.props.setGlobalLoading(true);
    this.props.logoutById(record.id).then((e: any) => {
      if (e.success) {
        notification.success({
          message: BIGDATA_CONSTANT.message.default.title.success,
          description: 'Logout successfully',
          icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
        });
      } else {
        notification.error({
          message: BIGDATA_CONSTANT.message.default.title.error,
          description: 'Logout fail',
        });
      }
      this.props.setGlobalLoading(false);
    });
  };

  componentDidMount = () => {
    this.load();
    this.props.updateMetaTitle({ title: BIGDATA_CONSTANT.trackTitle.MyToken });
    this.timer = setTimeout(() => {
      this.props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.MyToken,
        title: BIGDATA_CONSTANT.trackTitle.MyToken,
        app: 'ACCOUNT',
        url: getCurrentURL(this.props.location),
      });
      clearTimeout(this.timer);
    }, 5000);
  };
  timer: any;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  load = () => {
    this.props.setGlobalLoading(true);

    this.props.getUserTokens(this.state.criteria).then(() => {
      this.props.setGlobalLoading(false);
    });
  };

  renderContentLayout = (version?: string) => {
    return (
      <>
        {version === 'v2' && (
          <Tabs
            defaultActiveKey='security'
            onChange={(key: string) => {
              if (key === 'my-profile')
                this.props.history.push({ pathname: '/my-account-info', search: this.props.location.search });
              if (key === 'security')
                this.props.history.push({ pathname: '/security/2fa-security', search: this.props.location.search });
              if (key === 'activity')
                this.props.history.push({ pathname: '/activity/invitation', search: this.props.location.search });
            }}
          >
            <Tabs.TabPane tab='My Profile' key='my-profile' />
            <Tabs.TabPane tab='Security' key='security' />
            <Tabs.TabPane tab='Activity' key='activity' />
          </Tabs>
        )}

        <Layout>
          <Layout.Sider
            width={200}
            style={{ background: '#fff' }}
            className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}
          >
            <Menu mode='inline' defaultSelectedKeys={['tokens']} style={{ height: '100%' }}>
              <Menu.Item key='sercurity'>
                <LinkO2O {...this.props} to={{ pathname: '/security/2fa-security' }}>
                  Two-Factor Auth
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='change-password'>
                <LinkO2O {...this.props} to={{ pathname: '/security/change-password' }}>
                  Change Password
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='api'>
                <LinkO2O {...this.props} to={{ pathname: '/security/my-account-api' }}>
                  API Account
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='tokens'>
                <LinkO2O {...this.props} to={{ pathname: '/security/my-account-tokens' }}>
                  Token
                </LinkO2O>
              </Menu.Item>
            </Menu>
          </Layout.Sider>
          <Layout.Content className='pl30 pt10'>
            <Row gutter={[20, 20]}>
              <Col xs={24}>
                <Typography.Title level={4} className='mb0'>
                  Token
                </Typography.Title>
              </Col>
              <Col xs={24}>
                <FilterUserToken
                  onSearch={(values) => {
                    this.setState(
                      (prevState: any) => ({
                        criteria: {
                          ...prevState.criteria,
                          ...values,
                        },
                      }),
                      this.load
                    );
                  }}
                  loading={false}
                />
              </Col>
              <Col xs={24}>
                <InfoList
                  list={this.props.userTokens}
                  loading={this.props.ui.isLoading}
                  refresh={() => {
                    this.load();
                  }}
                />
              </Col>
              <Col xs={24} lg={24}>
                <Table
                  size='small'
                  key='id'
                  style={{ fontSize: 12 }}
                  columns={this.state.columns}
                  dataSource={this.props.userTokens.results.content}
                  pagination={false}
                  loading={this.props.ui.isLoading}
                  expandedRowRender={(record: TypeUserToken) => (
                    <CustomDescriptions column={1} title='Token Detail' className='Test'>
                      <Descriptions.Item label='Id'>{record.id || '--'}</Descriptions.Item>
                      <Descriptions.Item label='Token'>{record.token || '--'}</Descriptions.Item>
                      <Descriptions.Item label='Api key'>{record.apiKey || '--'}</Descriptions.Item>
                      <Descriptions.Item label='Ip Address'>{record.ipAddress || '--'}</Descriptions.Item>
                      <Descriptions.Item label='User Agent'>{record.userAgent || '--'}</Descriptions.Item>
                      <Descriptions.Item label='Expired At'>
                        {record.expiredAt ? (
                          <FormattedDate
                            value={new Date(record.expiredAt)}
                            year='numeric'
                            month='2-digit'
                            day='2-digit'
                            hour='2-digit'
                            minute='2-digit'
                            second='2-digit'
                          />
                        ) : (
                          '--'
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label='Last Accessed At'>
                        {record.lastAccessedAt ? (
                          <FormattedDate
                            value={new Date(record.lastAccessedAt)}
                            year='numeric'
                            month='2-digit'
                            day='2-digit'
                            hour='2-digit'
                            minute='2-digit'
                            second='2-digit'
                          />
                        ) : (
                          '--'
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label='Location'>{record.geoLocation || '--'}</Descriptions.Item>
                    </CustomDescriptions>
                  )}
                  scroll={{ x: 'calc(900px + 50%)' }}
                />
              </Col>
              <Col xs={24}>
                <O2OCustomPaging
                  list={this.props.userTokens}
                  onChange={(e: number) => {
                    this.setState(
                      (prevState: any) => ({
                        criteria: {
                          ...prevState.criteria,
                          page: e,
                        },
                      }),
                      this.load
                    );
                  }}
                  onChangePageSize={(e: number) => {
                    this.setState(
                      (prevState: any) => ({
                        criteria: {
                          ...prevState.criteria,
                          page: 0,
                          pageSize: e,
                        },
                      }),
                      this.load
                    );
                  }}
                />
              </Col>
            </Row>
          </Layout.Content>
        </Layout>
      </>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        selectedLeftNavStandard='my-security'
        selectedSubMenuStandard='my-security'
        selectedLeftNavModern='my-info'
        selectedSubMenuModern='my-info'
        breadcrumbItemsStandard={[
          { title: 'Home', path: '/' },
          { title: 'Security', path: '/security/2fa-security' },
          { title: 'Tokens' },
        ]}
        breadcrumbItemsModern={[
          { title: 'Account', path: '/' },
          { title: 'Profile', path: '/security/2fa-security' },
          { title: 'Security' },
        ]}
        pageTitle='Profile'
        renderContentLayout={this.renderContentLayout}
        metaTitle={this.props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.46644 16.3333H13.5335C14.8691 16.3333 15.5 15.9188 15.5 15.0228C15.5 12.7695 12.6476 9.53332 7.99663 9.53332C3.35234 9.53332 0.5 12.7695 0.5 15.0228C0.5 15.9188 1.13087 16.3333 2.46644 16.3333ZM2.13758 15.2167C1.80873 15.2167 1.68792 15.1298 1.68792 14.8891C1.68792 13.3311 3.96308 10.6566 7.99663 10.6566C12.0369 10.6566 14.3121 13.3311 14.3121 14.8891C14.3121 15.1298 14.1913 15.2167 13.8624 15.2167H2.13758ZM8.01003 8.39661C10.0436 8.39661 11.6812 6.61134 11.6812 4.39816C11.6812 2.22508 10.0436 0.5 8.01003 0.5C5.98322 0.5 4.33221 2.25183 4.33221 4.41153C4.33221 6.61803 5.9765 8.39661 8.01003 8.39661ZM8.01003 7.27998C6.64764 7.27998 5.52013 6.02295 5.52013 4.41153C5.52013 2.84691 6.64093 1.61662 8.01003 1.61662C9.37917 1.61662 10.4933 2.82686 10.4933 4.39816C10.4933 6.00958 9.3725 7.27998 8.01003 7.27998Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
      />
    );
  }
}
